<ul *ngIf="!isLoading" class="menu-list">
  <li
    *ngFor="let item of data"
    (click)="handleListClick(item.id, item, $event)"
    class="menu-list-item"
    [ngClass]="{ active: item.selected }"
  >
    <span
      [ngClass]="{ 'menu-highlight-text': searchedValue }"
      [innerHtml]="item.label | textHighlight: searchedValue"
    >
    </span>
    <span *ngIf="item.count !== undefined">&nbsp;({{ item.count }})</span>
  </li>
</ul>

<app-custom-skeleton
  *ngIf="isLoading"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="menu-skeleton"
></app-custom-skeleton>
